/**
 * ProviderLayout
 * Layout wrapper with sidebar and content area.
 */
import React from 'react';
import PropTypes from 'prop-types';
import ProviderSidebar from './ProviderSidebar';

export default function ProviderLayout({ children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <ProviderSidebar />
      <main
        style={{
          flex: 1,
          padding: '32px',
          overflowY: 'auto',
          maxWidth: 'calc(100vw - 240px)',
        }}
      >
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {children}
        </div>
      </main>
    </div>
  );
}

ProviderLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
